import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  isLoggedIn: false
};

export const examHallReducer = createReducer(initialState, {
  [types.EXAM_HALL_LIST_RESPONSE](state, action) {
    return {
      ...state,
      timestamp: action.response.timestamp,
      data: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.EXAM_HALL_PLAYER_RESPONSE](state, action) {
    return {
      ...state,
      livePlayerData: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState
    };
  }
});
